<template>
  <div>
    <Navbar />
    <div class="w-section page-header _404">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay _404"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="w-editable page-header-title"
          >
            Sorry, page not found!
          </h1>
          <h1
            data-ix="fade-in-on-load-2"
            class="page-header-title subtitle"
          >
            404:&nbsp;Page Error
          </h1>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'

export default {
  name: 'NotFound',
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    // eslint-disable-next-line
    $(Webflow.destroy)
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },
  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },
}
</script>

<style scoped>
.page-header-overlay,
._404 {
  height: 100vh;
}
</style>
